import { useLocalSearchParams } from "expo-router";
import { AssessmentEditTemplate } from "app/features/assessments/templates/AssessmentEditTemplate";
import { ScrollView } from "react-native";

export default function AssessmentEditPage() {
  const { id } = useLocalSearchParams();
  const numericId = id && !isNaN(Number(id)) ? Number(id) : undefined;

  return (
    <ScrollView
      className={"flex-1"}
      contentContainerClassName="px-dashboard flex-1"
    >
      <AssessmentEditTemplate id={numericId} />
    </ScrollView>
  );
}
